export default [
    {
        path: 'relatorio-movimentacao-psicotropico',
        component: () => import(
            /* webpackChunkName: 'farmacia-relatorio-movimentacao-psicotropico' */
            '@/views/farmacia/relatorio-movimentacao-psicotropico/Index'
        ),
        redirect: 'relatorio-movimentacao-psicotropico/index',
        children: [
            {
                name: 'farmacia-relatorio-movimentacao-psicotropico-index',
                path: 'index',
                component: () => import(
                    /* webpackChunkName: 'farmacia-relatorio-movimentacao-psicotropico' */
                    '@/views/farmacia/relatorio-movimentacao-psicotropico/List.vue'
                ),
            },
        ],
    },
]